
function makeArray(val) {
    if (angular.isUndefined(val)) {
        return [];
    } else if (!angular.isArray(val)) {
        return [val];
    }
    return val;
}

module.factory('FormService', function($window, $rootScope, $location) {

    var message = "You have unsaved changes on this page. If you " +
        "navigate away they will be lost. Continue?";

    var forms = {};
    var formSerivce = {};
    var openForms = [];
    var interceptsActive = false;
    var stateChangeDeregistration = angular.noop;


    function dirtyOpenExists() {
        for (var i = 0; i < openForms.length; i++) {
            if (forms[openForms[i]] && forms[openForms[i]].isDirty()) {
                return true;
            }
        }
        return false;
    }

    function beforeUnloadHandler(event) {
        if (dirtyOpenExists()) {
            (event || $window.event).returnValue = message;
            return message;
        }
    }

    function stateChangeHandler(event, toState, toParams) {
        console.log(event);
        if (dirtyOpenExists()) {
            if (!$window.confirm(message)) {
                event.preventDefault();
            }
        }
    }


    function activateIntercepts() {
        $window.addEventListener('beforeunload', beforeUnloadHandler);
        stateChangeDeregistration = $rootScope.$on(
            '$stateChangeStart', stateChangeHandler);
        interceptsActive = true;
    }

    function deactivateIntercepts() {
        $window.removeEventListener('beforeunload', beforeUnloadHandler);
        stateChangeDeregistration();
        interceptsActive = false;
    }

    formSerivce.addForm = function(name, controller) {
        forms[name] = controller;
    };

    formSerivce.removeForm = function(name) {
        delete forms[name];
    };


    $rootScope.$on('formEvent', function(event, name, type) {
        var index = openForms.indexOf(name);
        if (index === -1 && type === 'open') {
            openForms.push(name);
        }
        if (type === 'close' && index >= 0) {
            openForms.splice(index, 1);
        }

        if (openForms.length > 0 && !interceptsActive) {
            activateIntercepts();
        } else {
            deactivateIntercepts();
        }
    });


    $rootScope.$watch(function() {
        return $location.search().edit;
    }, function(editing) {
        editing = makeArray(editing);
        for (var i = 0; i < editing.length; i++) {
            if (forms[editing[i]]) {
                forms[editing[i]].open();
            }
        }
    });

    return formSerivce;

});
